import { Box } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Box)`
  background: white;
  box-shadow: ${({ theme }) => theme.shadows[0]};
`;

export const Title = styled.h1`
  margin-top: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const FormContainer = styled(Box)`
  background: #fff;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  color: #fff;
  padding: ${({ theme }) => theme.spacing(6)};
`;
